import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AlertController } from '@ionic/angular';
import { BackendService } from '../core/services/backend-prod.service';
import { HelperService } from '../core/services/helper.service';
import { Storage } from '@ionic/storage';
import { debounceTime } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-database-env',
  templateUrl: './database-env.html',
  styleUrls: ['./database-env.scss'],
})
export class DatabaseEnvPage implements OnInit {

  private incomingSearchText$ = new BehaviorSubject('');
  breadcrumbList = [
    {
      label: 'Database Environment',
      url: '/baseapp/database-env'
    },
    {
      label: 'List',
      url: '/baseapp/database-env'
    }
  ];

  dbEnvDisplayedColumns: string[] = ['storage_name', 'dbversion', 'jdbc_driver','jdbc_string','jar_file_name','action'];
  databaseEnvSource: any;
  hide1200 = false;
  page_min = 0;
  page_max = 10;
  total_records = 0;
  sortBy: string = "";
  orderBy: string = "DESC";
  search = "";
  loading = true;
  bubbleshow: boolean = false;

  constructor(
    public breakpointObserver: BreakpointObserver,
    private backendService: BackendService,
    private router: Router,
    public storage: Storage,
    public alertController: AlertController,
    public helperService: HelperService) { }

  ngOnInit() {
    this.helperService.getNavHelp().subscribe(toggle => {
      if(toggle){
        this.closebubblecross();
      }
    });
    this.getDatabaseEnv();
    this.incomingSearchText$.pipe(debounceTime(500)).subscribe((value) => {
      this.search = value;
      // this.searchDatabaseEnv();
    });
    this.breakpointObserver.observe(['(min-width: 1200px)']).subscribe((state: BreakpointState) => {
      if (state.matches) {
        this.hide1200 = true;
      } else {
        this.hide1200 = false;
      }
    });
    this.getStorage().then((res)=>{
      if(res.showDialog == 1){
        this.bubbleshow = true;
      }else{
        this.bubbleshow = false;
      }
    })
  }


  async confirmDeleteAlert(header, msg, userId) {
    const alert = await this.alertController.create({
      header: header,
      message: msg,
      buttons: [
        {
          text: 'CANCEL',
          cssClass: 'primary-text',
          handler: () => {
            alert.dismiss();
          }
        }, {
          text: 'OK',
          cssClass: 'primary-text',
          handler: () => {
            this.deleteDatabaseEnv(userId)
          }
        }
      ]
    });
    await alert.present();
  }

  searchDatabaseEnv(){
    this.getStorage().then((res)=>{
      let payload = {
        min: this.page_min,
        max: this.page_max,
        sort: this.sortBy,
        order: this.orderBy,
        q: this.search
      }

      this.backendService.GetAPICall('getJDBCenv', res.token).subscribe(
        data => {
          this.databaseEnvSource = data.records;
          this.total_records = data.total_count;
        },
        (error)=>{
          //console.log(error);
          this.helperService.handleError(error);
        }
      );
    })
  }

  getDatabaseEnv(){
    this.getStorage().then(async (res)=>{
      await this.helperService.loader();
      let payload = {
        min: this.page_min,
        max: this.page_max,
        sort: this.sortBy,
        order: this.orderBy,
        q: this.search
      }
      //console.log(res);
      this.backendService.GetAPICall('getJDBCenv', res.token).subscribe(
        data => {
          //console.log(data);
          this.helperService.closeLoader();
          this.databaseEnvSource = data;
          // this.total_records = data.total_count;
          this.loading = false;
        },
        (error)=>{
          //console.log(error);
          this.loading = false;
          this.helperService.handleError(error);
              this.helperService.closeLoader();
        }
      );
    })
  }

  searchStringMethod(message: string) {
		this.incomingSearchText$.next(message);
	}

  clearSearch(){
    this.search = "";
    this.searchStringMethod(this.search);
  }

  getSearchOnChange(e){
    this.searchStringMethod(e);
  }

  loadMore(event) {
    this.helperService.loader()
    // this.page_min = this.page_max;
    this.page_max = this.page_max + 10;
    let payload = {
      min: this.page_min,
      max: this.page_max
    }
    this.getStorage().then((res)=>{
      
        this.backendService.GetAPICall('getJDBCenv', res.token).subscribe(
        data => {
          this.helperService.closeLoader();
          // this.databaseEnvSource = this.databaseEnvSource.concat(data.records);
          this.databaseEnvSource = data.records;
          event.target.complete();
          if(data.records.length == this.total_records){
            event.target.disabled = true;
            // this.helperService.presentToast('No more data', 2000);
          }
        },
        (error)=>{
          //console.log(error);
          event.target.complete();
          this.helperService.handleError(error);
              this.helperService.closeLoader();
        }
      );
    })
  }

  async getStorage () {
    let data = {
      token: await this.storage.get("token"),
      userId: await this.storage.get("id"),
      showDialog: await this.storage.get("showDialog")
    }
    return data;
  }

  editDatabase(id){
    this.router.navigate(['baseapp/database-env/update', id])
  }
  viewDatabaseDetails(id){
    this.router.navigate(['baseapp/database-env/details', id])
  }

  confirmDelete(userId) {
    const header = 'Confirm!';
    const msg = "Are you sure you want to delete?"
    this.confirmDeleteAlert(header, msg, userId,)
  }

  deleteDatabaseEnv(id){
    this.getStorage().then(async (res)=>{
      await this.helperService.loader();
      let url = `/api/users/deleteJDBCenv/${id}`;
      this.backendService.DeleteAPICall(url, res.token).subscribe(
        (res) => {
          //console.log("inidsd", res);
          this.helperService.closeLoader();
          this.helperService.presentToast(res.msg, 2000);
          this.getDatabaseEnv();
        },
        (error)=>{
          //console.log(error);
          this.helperService.handleError(error);
              this.helperService.closeLoader();
        }
      );
    })
  }

  closebubblecross(){
    this.bubbleshow = false;
  }

  closebubble(){
    this.bubbleshow = false;
  }
  
}
